import styles from '../MontlyRevenue.module.scss'

const Summary = ({
  firstYear = 2020,
  secondYear = 2021,
  label = 'revenue',
  firstYearValue = '$370,252',
  secondYearValue = '$370,252',
  deltaPercentage = 8.2,
  isHighDeltaGood = true,
  firstYearColor,
  secondYearColor,
  name
}) => (
  <div className={styles.summaryHolder}>
    {name && (
      <div className={styles.summaryNameHolder}>
        <p className={styles.summaryName}>{name}</p>
      </div>
    )}
    <div className={styles.summaryValueHolder}>
      <p className={styles.summaryLabel}>
        <div
          className={styles.summaryBullet}
          style={{
            backgroundColor: firstYearColor
          }}
        ></div>
        {firstYear} {label}
      </p>
      <p className={styles.summaryValue}>{firstYearValue}</p>
    </div>
    <div className={styles.summaryValueHolder}>
      <p className={styles.summaryLabel}>
        <div
          className={styles.summaryBullet}
          style={{
            backgroundColor: secondYearColor
          }}
        ></div>
        {secondYear} {label}
      </p>
      <p className={styles.summaryValue}>
        {secondYearValue}

        {isHighDeltaGood ? (
          <>
            {deltaPercentage > 0 ? (
              <span className={styles.deltaPercentageGood}>{deltaPercentage}%</span>
            ) : (
              <span className={styles.deltaPercentageBad}>{deltaPercentage}%</span>
            )}
          </>
        ) : (
          <>
            {deltaPercentage > 0 ? (
              <span className={styles.deltaPercentageBad}>{deltaPercentage}%</span>
            ) : (
              <span className={styles.deltaPercentageGood}>{deltaPercentage}%</span>
            )}
          </>
        )}
      </p>
    </div>
  </div>
)

export default Summary
